import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const MemberStatusList = Loadable(
  lazy(() => import("features/memberStatus/components/List"))
);
const MemberStatusPage = Loadable(
  lazy(() => import("features/memberStatus/components/Page"))
);

const routes = {
  path: "memberStatus",
  children: [
    { path: "", element: <MemberStatusList /> },
    { path: "add", element: <MemberStatusPage /> },
    { path: "edit/:memberStatusID?", element: <MemberStatusPage /> },
  ],
};

export default routes;
